import { forwardRef } from 'react';
import { StyledImg } from './styled';

const Img = forwardRef((props, ref) => <StyledImg ref={ref} {...props} />);

export default Img;
